import React from 'react';
import { useClerk } from '@clerk/clerk-react';
import { SaveStatus, SlimBar } from '../v2/ds';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useOnboardingSaveStatus } from '../../hooks/useOnboardingSaveStatus';
import { V2_PAGE_MAIN_CLASS } from './v2Shell';

/**
 * The frame a brand's users see while it onboards (spec D9; onboarding-vera-mock
 * `.bar`): no portal navigation (every portal page is locked), just the logo,
 * the brand with "Onboarding" under it, the save status and Sign out.
 */
export function OnboardingFrame({
  children,
  brandName,
  footer,
}: {
  children: React.ReactNode;
  /** DEV preview only: the fixture brand's name when no user is signed in. */
  brandName?: string;
  /** DEV preview only: a bar under the page. */
  footer?: React.ReactNode;
}): React.ReactElement {
  const { signOut } = useClerk();
  const { user } = useCurrentUser();
  const save = useOnboardingSaveStatus();
  return (
    <div className="flex h-screen flex-col bg-page">
      <SlimBar
        title={user?.brand?.displayName ?? brandName ?? 'GlobalBridge'}
        subtitle="Onboarding"
        status={<SaveStatus state={save.state} at={save.at} />}
        onSignOut={() => void signOut()}
      />
      <main id="frame-main" className={`${V2_PAGE_MAIN_CLASS} flex min-h-0 flex-col`}>
        {children}
      </main>
      {footer}
    </div>
  );
}

export default OnboardingFrame;
